import { CellContext } from '@tanstack/react-table';
import { CellProps } from 'react-table';

import { ReViewModel } from '@work4all/models/lib/Classes/ReViewModel.entity';
import { RePermitStatus } from '@work4all/models/lib/Enums/RePermitStatus.enum';

import {
  canApproveOwnInboundInvoices,
  canForwardInboundInvoices,
} from '@work4all/utils/lib/permissions';

import { PermitStatusIconCell } from '../../PermitStatusIconCell';
import { mapSelectedRowStatus } from '../utils';

export const ReStatusCell = (cellProps: CellProps<ReViewModel>) => {
  return (
    <PermitStatusIconCell
      {...cellProps}
      value={mapSelectedRowStatus(
        cellProps.value,
        cellProps.row.values.paymentStatus
      )}
      canApprove={canApproveOwnInboundInvoices}
      canForward={canForwardInboundInvoices}
      view="list"
    />
  );
};

ReStatusCell.v8 = function ReStatusCellV8(
  props: CellContext<ReViewModel, RePermitStatus>
) {
  return (
    <PermitStatusIconCell
      row={{ ...props.row, values: props.row.original } as any}
      value={mapSelectedRowStatus(
        props.getValue(),
        props.row.original.paymentStatus as any
      )}
      canApprove={canApproveOwnInboundInvoices}
      canForward={canForwardInboundInvoices}
      view="list"
    />
  );
};
